import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pe from "@/locales/pe.json";
import en from "@/locales/en.json";

i18n.use(initReactI18next).init({
  resources: {
    pe: { translation: pe },
    en: { translation: en },
  },
  lng: "pe",
  fallbackLng: "pe",
  supportedLngs: ["pe", "en"],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
